import HeroComponent from './Hero.vue'
export default HeroComponent
